'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var EventEmitter = require('events').EventEmitter;

var Block = require('ipld-block');

var CONSTANTS = require('./constants');

var logger = require('./utils').logger;

var cidToMultihashString = function cidToMultihashString(cid) {
  return cid.multihash.toString('base64');
};

var unwantEvent = function unwantEvent(cid) {
  return "unwant:".concat(cidToMultihashString(cid));
};

var blockEvent = function blockEvent(cid) {
  return "block:".concat(cidToMultihashString(cid));
};
/**
 * Internal module used to track events about incoming blocks,
 * wants and unwants.
 *
 * @param {PeerId} peerId
 * @private
 */


var Notifications = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Notifications, _EventEmitter);

  var _super = _createSuper(Notifications);

  function Notifications(peerId) {
    var _this;

    _classCallCheck(this, Notifications);

    _this = _super.call(this);

    _this.setMaxListeners(CONSTANTS.maxListeners);

    _this._log = logger(peerId, 'notif');
    return _this;
  }
  /**
   * Signal the system that we received `block`.
   *
   * @param {Block} block
   * @return {void}
   */


  _createClass(Notifications, [{
    key: "hasBlock",
    value: function hasBlock(block) {
      var event = blockEvent(block.cid);

      this._log(event);

      this.emit(event, block);
    }
    /**
     * Signal the system that we are waiting to receive the
     * block associated with the given `cid`.
     * Returns a Promise that resolves to the block when it is received,
     * or undefined when the block is unwanted.
     *
     * @param {CID} cid
     * @param {Object} options
     * @param {AbortSignal} options.abortSignal
     * @returns {Promise<Block>}
     */

  }, {
    key: "wantBlock",
    value: function wantBlock(cid) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!cid) {
        throw new Error('Not a valid cid');
      }

      var blockEvt = blockEvent(cid);
      var unwantEvt = unwantEvent(cid);

      this._log("wantBlock:".concat(cid));

      return new Promise(function (resolve, reject) {
        var onUnwant = function onUnwant() {
          _this2.removeListener(blockEvt, onBlock);

          reject(new Error("Block for ".concat(cid, " unwanted")));
        };

        var onBlock = function onBlock(block) {
          _this2.removeListener(unwantEvt, onUnwant);

          if (!cid.multihash.equals(block.cid.multihash)) {
            // wrong block
            return reject(new Error("Incorrect block received for ".concat(cid)));
          } else if (cid.version !== block.cid.version || cid.codec !== block.cid.codec) {
            // right block but wrong version or codec
            block = new Block(block.data, cid);
          }

          resolve(block);
        };

        _this2.once(unwantEvt, onUnwant);

        _this2.once(blockEvt, onBlock);

        if (options && options.signal) {
          options.signal.addEventListener('abort', function () {
            _this2.removeListener(blockEvt, onBlock);

            _this2.removeListener(unwantEvt, onUnwant);

            reject(new Error("Want for ".concat(cid, " aborted")));
          });
        }
      });
    }
    /**
     * Signal that the block is not wanted anymore.
     *
     * @param {CID} cid - the CID of the block that is not wanted anymore.
     * @returns {void}
     */

  }, {
    key: "unwantBlock",
    value: function unwantBlock(cid) {
      var event = unwantEvent(cid);

      this._log(event);

      this.emit(event);
    }
  }]);

  return Notifications;
}(EventEmitter);

module.exports = Notifications;